export const selectRolePermissionRoles = (state) =>
    state.rolePermissions?.roles || [];

export const selectRolePermissionPermissions = (state) =>
    state.rolePermissions?.permissions || [];

export const selectRolePermissionLoading = (state) =>
    state.rolePermissions?.loading || false;